<div class="map-container"> <projects-map [draggable]="true"></projects-map> </div> 